"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.OPTION_SIZE = exports.SEGMENTED_THEME = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUtils = require("@bit/gerenciatd.utils.tagging-utils");

require("./SegmentedInput.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SegmentedInputPart = function SegmentedInputPart(_ref) {
  var checked = _ref.checked,
      option = _ref.option,
      optionSize = _ref.optionSize,
      selectedClass = _ref.selectedClass,
      onChange = _ref.onChange;

  var handleChange = function handleChange() {
    onChange(option);
  };

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
    type: "radio",
    name: option.name,
    defaultChecked: checked,
    value: option.value
  }), /*#__PURE__*/_react["default"].createElement("label", {
    onClick: handleChange,
    className: "".concat(optionSize, " ").concat(selectedClass)
  }, option.label));
};

var SEGMENTED_THEME = {
  WHITENBLUE: 'whiteNBlue'
};
exports.SEGMENTED_THEME = SEGMENTED_THEME;
var OPTION_SIZE = {
  SIMPLE: 'simple',
  DOUBLE: 'double'
};
/**
 * Stateless component to draw a segmented input
 * @param {array} options options to be drawed
 * @param {string} defaultValue value to be selected by default
 * @param {func} onChange function to execute when user changes the selection
 * @param {string} wrapperClass wrapper class for the whole component,
 * @param {string} optionSize size selected from OPTION_SIZE
 * @param {string} theme theme for the input from SEGMENTED_THEME
 * @returns {JSX} Component JSX.
 */

exports.OPTION_SIZE = OPTION_SIZE;

var SegmentedInput = /*#__PURE__*/function (_Component) {
  _inherits(SegmentedInput, _Component);

  var _super = _createSuper(SegmentedInput);

  function SegmentedInput(props) {
    var _this;

    _classCallCheck(this, SegmentedInput);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (valueSelected) {
      _this.setState({
        segmentedValue: valueSelected.value
      });

      _this.props.onChange(valueSelected.value);

      var taggingType = 'boton';

      if (valueSelected.tagging) {
        console.log(valueSelected.tagging);
        (0, _gerenciatdUtils.sendTagging)(taggingType, valueSelected.tagging);
      }
    });

    _this.state = {
      segmentedValue: props.defaultValue
    };
    return _this;
  }

  _createClass(SegmentedInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          optionSize = _this$props.optionSize,
          options = _this$props.options,
          wrapperClass = _this$props.wrapperClass,
          theme = _this$props.theme;
      var segmentedValue = this.state.segmentedValue;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "segmentedInput ".concat(theme, " ").concat(wrapperClass)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "slide-container"
      }, options.map(function (option) {
        var checked = segmentedValue === option.value;
        var selectedClass = checked ? 'selected' : '';
        return /*#__PURE__*/_react["default"].createElement(SegmentedInputPart, {
          key: option.value,
          option: option,
          selectedClass: selectedClass,
          optionSize: optionSize,
          checked: checked,
          onChange: _this2.handleChange
        });
      })));
    }
  }]);

  return SegmentedInput;
}(_react.Component);

SegmentedInput.propTypes = {
  options: _propTypes["default"].array.isRequired,
  defaultValue: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func,
  wrapperClass: _propTypes["default"].string,
  optionSize: _propTypes["default"].string,
  theme: _propTypes["default"].string
};
SegmentedInput.defaultProps = {
  wrapperClass: '',
  optionSize: OPTION_SIZE.SIMPLE,
  onChange: function onChange() {},
  theme: SEGMENTED_THEME.WHITENBLUE
};
var _default = SegmentedInput;
exports["default"] = _default;

//# sourceMappingURL=index.js.map